import { OohCourierTrip, OohCourierVisit } from '../../graphql/types';

export const calculateCourierCharges = (courierTrip: OohCourierTrip): number => {
  return courierTrip.agencyCourierVisits.reduce(
    (acc, curr) => acc + (curr.visitPickupCharges ?? 0),
    0,
  );
};

export interface ActivityBar {
  label: string;
  value: number;
  color: string;
}

export const getActivityBars = (visit: OohCourierVisit): ActivityBar[] => {
  const activities: ActivityBar[] = [
    { label: 'Charges', value: visit.visitCharges ?? 0, color: '#22c55e' },
    { label: 'C2C Discharges', value: visit.visitDischargesC2C ?? 0, color: '#3b82f6' },
    { label: 'First Mile Discharges', value: visit.visitDischargesFirstMile ?? 0, color: '#f97316' },
    { label: 'Expired Discharges', value: visit.visitDischargesExpired ?? 0, color: '#ea2427' },
    { label: 'Returns Discharges', value: visit.visitDischargesReturn ?? 0, color: '#a855f7' },
  ];

  return activities.filter((activity) => activity.value > 0);
};

export const calculateMaxActivityValue = (activities: ActivityBar[]): number => {
  return Math.max(...activities.map((a) => a.value));
};